import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import { useIdentityContext } from 'react-netlify-identity/dist/index';

var AuthRecoveryRedirect = function AuthRecoveryRedirect(_ref) {
  var navigateTo = _ref.navigateTo;

  var _useIdentityContext = useIdentityContext(),
      _useIdentityContext$p = _useIdentityContext.param,
      token = _useIdentityContext$p.token,
      type = _useIdentityContext$p.type;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  if (token && type === 'recovery' && pathname === '/') {
    navigate(navigateTo || '/resetPassword', {
      replace: true,
      state: {
        token: token
      }
    });
  }

  return null;
};

AuthRecoveryRedirect.propTypes = {
  navigateTo: PropTypes.string
};
AuthRecoveryRedirect.defaultProps = {
  navigateTo: undefined
};
export default AuthRecoveryRedirect;